// @ts-nocheck
/* eslint-disable */
export const addLineIcon = {
  data: `<svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.16663 9.16699V4.16699H10.8333V9.16699H15.8333V10.8337H10.8333V15.8337H9.16663V10.8337H4.16663V9.16699H9.16663Z" fill="currentColor"/></svg>`,
  name: 'add-line' as const,
};
